import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { IMemberKeyValueDto, IMemberKeyValueList } from "src/app/models/keyvalue";
import { ConfigurationService } from "../configuration/configuration.service";
import { EndpointFactory } from "../endpoint-factory.service";
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class KvpManagerEndpointService extends EndpointFactory {
    constructor(http: HttpClient, private configurationService: ConfigurationService, injector: Injector) {
        super(http, configurationService, injector);
    }
    updateMemberKVPair(tenantId: string, memberId: string, request: IMemberKeyValueList): Promise<any> {
        const url =  `${this.configurationService.webAppApiBaseUrl}/member/${tenantId}/${memberId}/keys`;
        return this.http.put<any>(url, request).pipe(
          catchError(error => {
              return this.handleError(error);
          })).toPromise();
    }
    getMemberKVPairs(tenantId: string, memberId: string): Observable<IMemberKeyValueDto[]> {
        const url =  `${this.configurationService.webAppApiBaseUrl}/member/${tenantId}/${memberId}/keys`;
        return this.http.get<IMemberKeyValueDto[]>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }
    getMemberKVPair(tenantId: string, memberId: string, key: string): Observable<IMemberKeyValueDto> {
        const url =  `${this.configurationService.webAppApiBaseUrl}/member/${tenantId}/${memberId}/keys/${key}`;
        return this.http.get<IMemberKeyValueDto>(url).pipe(
            catchError(error => {
                return this.handleError(error);
            }));
    }
}